import assessmentReducer from '@/state/modules/assessment/reducers';

export { default as actions } from '@/state/modules/assessment/actions';
export { default as sagas } from '@/state/modules/assessment/sagas';
export { default as operations } from '@/state/modules/assessment/operations';
export { default as selectors } from '@/state/modules/assessment/selectors';

export default assessmentReducer;
